import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import styled from '@emotion/styled';
import ArticleBody from './InnerHtmlStyling';

const articleSamplePropertyTypes = {
  body: PropTypes.string,
  Component: PropTypes.elementType,
};

type ArticleSampleProperties = InferProps<
typeof articleSamplePropertyTypes
>;

const ArticleBodyWithOverlay = styled.div`
  position: absolute;
  visibility: hidden;
`;

const TruncatedArticleBody = styled(ArticleBody)`
  max-height: 14rem;
  overflow: hidden;
`;

const ArticleSample = ({
  body,
  Component,
}: ArticleSampleProperties) => (
  <>
    <ArticleBodyWithOverlay>
      <TruncatedArticleBody
        dangerouslySetInnerHTML={{ __html: body }}
        className="member-content"
      />
    </ArticleBodyWithOverlay>
    {Component && (<Component />)}
  </>
);

export default ArticleSample;
